/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AppVersionDTO } from '../models/AppVersionDTO';
import type { BankIdAttemptDto } from '../models/BankIdAttemptDto';
import type { BankIdStatusDto } from '../models/BankIdStatusDto';
import type { LoginCodeBodyDto } from '../models/LoginCodeBodyDto';
import type { LoginWithCodeResponseDto } from '../models/LoginWithCodeResponseDto';
import type { QrCodeDto } from '../models/QrCodeDto';
import type { QualifyResultDto } from '../models/QualifyResultDto';
import type { QuestionerAnswersDTOInput } from '../models/QuestionerAnswersDTOInput';
import type { QuestionerAnswersDTOOutput } from '../models/QuestionerAnswersDTOOutput';
import type { QuestionerAnswersDTOOutputSimple } from '../models/QuestionerAnswersDTOOutputSimple';
import type { QuestionerDTO } from '../models/QuestionerDTO';
import type { QuestionerIdDTOOutput } from '../models/QuestionerIdDTOOutput';
import type { SendSsToRelativeFromPatientDto } from '../models/SendSsToRelativeFromPatientDto';
import type { StartBankIdAuthBodyDto } from '../models/StartBankIdAuthBodyDto';
import type { TranslationApp } from '../models/TranslationApp';
import type { TranslationsDto } from '../models/TranslationsDto';
import type { UpdateOneTimeUserDto } from '../models/UpdateOneTimeUserDto';
import type { UploadedFileDto } from '../models/UploadedFileDto';
import type { UserProfileDto } from '../models/UserProfileDto';
import type { UserSettingsDto } from '../models/UserSettingsDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class WebTestsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get questioners for user
     * @param xClientRequester Who is requesting questioners
     * @returns QuestionerDTO
     * @throws ApiError
     */
    public getQuestioners(
        xClientRequester: string,
    ): CancelablePromise<Array<QuestionerDTO>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/questioner',
            headers: {
                'x-client-requester': xClientRequester,
            },
        });
    }

    /**
     * @returns QuestionerDTO
     * @throws ApiError
     */
    public getFaq(): CancelablePromise<QuestionerDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/questioner/faq',
        });
    }

    /**
     * Get vitalis demo result
     * @param id
     * @returns QuestionerAnswersDTOOutput
     * @throws ApiError
     */
    public getVitalisResult(
        id: string,
    ): CancelablePromise<QuestionerAnswersDTOOutput> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/questioner-answer/vitalis/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Save new user answer on questioner. Returns id of created answer
     * @param requestBody
     * @returns QuestionerIdDTOOutput
     * @throws ApiError
     */
    public create(
        requestBody: QuestionerAnswersDTOInput,
    ): CancelablePromise<QuestionerIdDTOOutput> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/questioner-answer',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Save new user answer on questioner. Returns id of created answer. Can be performed only by one time user
     * @param requestBody
     * @returns QuestionerIdDTOOutput
     * @throws ApiError
     */
    public createAsOneTimeUser(
        requestBody: QuestionerAnswersDTOInput,
    ): CancelablePromise<QuestionerIdDTOOutput> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/questioner-answer/one-time-respondent',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Update existent answer as a one time user
     * @param id
     * @param requestBody
     * @returns QuestionerAnswersDTOOutputSimple
     * @throws ApiError
     */
    public updateAsOneTimeUser(
        id: string,
        requestBody: QuestionerAnswersDTOInput,
    ): CancelablePromise<QuestionerAnswersDTOOutputSimple> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/questioner-answer/{id}/one-time-respondent',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Update existent answer as a patient
     * @param id
     * @param requestBody
     * @returns QuestionerAnswersDTOOutputSimple
     * @throws ApiError
     */
    public update(
        id: string,
        requestBody: QuestionerAnswersDTOInput,
    ): CancelablePromise<QuestionerAnswersDTOOutputSimple> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/questioner-answer/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Check if user was qualified to pass tests
     * @returns QualifyResultDto
     * @throws ApiError
     */
    public checkIsQualified(): CancelablePromise<QualifyResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/questioner-answer/check-qualified',
        });
    }

    /**
     * Get last unfinished questioner-answer for patient
     * @param kind
     * @returns QuestionerAnswersDTOOutputSimple
     * @throws ApiError
     */
    public getUnfinishedQuestionerAnswer(
        kind: string,
    ): CancelablePromise<QuestionerAnswersDTOOutputSimple> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/questioner-answer/unfinished/{kind}',
            path: {
                'kind': kind,
            },
        });
    }

    /**
     * Get translations batch
     * @param apps
     * @returns TranslationsDto
     * @throws ApiError
     */
    public getBatch(
        apps: Array<TranslationApp>,
    ): CancelablePromise<TranslationsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/translations/batch',
            query: {
                'apps': apps,
            },
        });
    }

    /**
     * @returns AppVersionDTO
     * @throws ApiError
     */
    public getAppVersions(): CancelablePromise<AppVersionDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/project-setting/app-version',
        });
    }

    /**
     * Create cloud file. Accepts form-data with the file. Returns a link to the file
     * @param formData
     * @returns UploadedFileDto
     * @throws ApiError
     */
    public upload(
        formData: {
            /**
             * File to upload
             */
            file: Blob;
        },
    ): CancelablePromise<UploadedFileDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/cloud-file',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * Sends and sms/email to the doctor that patient has finished answering questions.
     * @returns any
     * @throws ApiError
     */
    public notifyFinishedAnswering(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/med-staff/notify-finished-answering',
        });
    }

    /**
     * Mark that current user allowed us to export his data
     * @param dataExportAllowed
     * @returns any
     * @throws ApiError
     */
    public acceptTermsAndConditions(
        dataExportAllowed: string,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/user/accept-terms-and-conditions',
            query: {
                'dataExportAllowed': dataExportAllowed,
            },
        });
    }

    /**
     * Get basic profile info for mobile app
     * @returns UserProfileDto
     * @throws ApiError
     */
    public getProfile(): CancelablePromise<UserProfileDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/profile',
        });
    }

    /**
     * Get user settings
     * Retrieve the current user's notification preferences and settings
     * @returns UserSettingsDto
     * @throws ApiError
     */
    public getSettings(): CancelablePromise<UserSettingsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/settings',
        });
    }

    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public sendSsToRelativeFromPatient(
        requestBody: SendSsToRelativeFromPatientDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sms/send-ss/to-relative-from-patient',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public sendFaqToRelativeFromPatient(
        requestBody: SendSsToRelativeFromPatientDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sms/send-faq/to-relative-from-patient',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Start auth attempt with BankId
     * @param requestBody
     * @returns BankIdAttemptDto
     * @throws ApiError
     */
    public startBankIdAuth(
        requestBody: StartBankIdAuthBodyDto,
    ): CancelablePromise<BankIdAttemptDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/auth/start-bankid',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Check BankId Status
     * @param orderRef
     * @returns BankIdStatusDto
     * @throws ApiError
     */
    public bankIdStatus(
        orderRef: string,
    ): CancelablePromise<BankIdStatusDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/auth/bankid-status',
            query: {
                'orderRef': orderRef,
            },
        });
    }

    /**
     * Get BankId QR-code data
     * @param orderRef
     * @returns QrCodeDto
     * @throws ApiError
     */
    public getBankIdQrCodeData(
        orderRef: string,
    ): CancelablePromise<QrCodeDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/auth/qr-code',
            query: {
                'orderRef': orderRef,
            },
        });
    }

    /**
     * Login with login code
     * @param requestBody
     * @returns LoginWithCodeResponseDto
     * @throws ApiError
     */
    public loginWithCode(
        requestBody: LoginCodeBodyDto,
    ): CancelablePromise<LoginWithCodeResponseDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/auth/login-code',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Update info for one-time user
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public updateInfo(
        requestBody: UpdateOneTimeUserDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/one-time-auth/update-info',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Generate jwt for one-time-user by personal number
     * @param pnr
     * @returns string
     * @throws ApiError
     */
    public generateTestOneTimeUserJwtByPnr(
        pnr: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/one-time-auth/generate-test-one-time-user-jwt-by-pnr/{pnr}',
            path: {
                'pnr': pnr,
            },
        });
    }

}
